var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container rawhtml-block",class:_vm.theme_color},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }